import React, { useEffect, useMemo, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import "./GroupSelector.scss";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const GroupSelector = ({
  groups = [],
  selectedIds = [],
  onChange,
  searchTerm,
  onSearchChange,
  selectionType = "single",
  disabled = false,
  isLoading = false,
  label = "Сообщества",
  placeholder = "Название или ID группы",
}) => {
  const [expandedRegions, setExpandedRegions] = useState({});

  useEffect(() => {
    setExpandedRegions((prev) =>
      groups.reduce(
        (acc, region) => ({ ...acc, [region.region]: prev[region.region] ?? false }),
        {}
      )
    );
  }, [groups]);

  const filteredGroups = useMemo(
    () =>
      groups
        .map((region) => ({
          ...region,
          groups: region.groups.filter(
            (group) =>
              group.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
              group.group_id.toLowerCase().includes(searchTerm.toLowerCase())
          ),
        })),
    [groups, searchTerm]
  );

  const toggleRegion = (regionName) => {
    setExpandedRegions((prev) => ({
      ...prev,
      [regionName]: !prev[regionName],
    }));
  };

  const handleSelect = (groupId) => {
    if (selectionType === "single") {
      onChange([groupId]);
      return;
    }

    const exists = selectedIds.includes(groupId);
    const next = exists
      ? selectedIds.filter((id) => id !== groupId)
      : [...selectedIds, groupId];

    onChange(next);
  };

  return (
    <Form.Group className="group-selector">
      <Form.Label className="fw-bold group-selector__label">{label}</Form.Label>
      <Form.Control
        type="text"
        className="mb-3 group-selector__search"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        disabled={disabled}
      />
      <div className="groups-list group-selector__list">
        {isLoading ? (
          <div className="text-center group-selector__loading">
            <Spinner animation="border" variant="primary" />
            <p className="mb-0">Загружаем группы...</p>
          </div>
        ) : filteredGroups.length > 0 ? (
          filteredGroups.map((region) =>
            region.groups.length > 0 ? (
              <div key={region.region} className="region-section group-selector__region">
                <div
                  className="region-header group-selector__region-header"
                  onClick={() => toggleRegion(region.region)}
                  role="button"
                >
                  <h6 className="mb-0">{region.region}</h6>
                  <span
                    className={`accordion-icon group-selector__accordion-icon ${
                      expandedRegions[region.region] ? "expanded" : ""
                    }`}
                  >
                    <ExpandMoreIcon />  
                  </span>
                </div>
                {expandedRegions[region.region] && (
                  <div className="region-groups group-selector__region-groups">
                    {region.groups.map((group) => (
                      <div key={group.id} className="form-check group-selector__item">
                        <input
                          className="form-check-input"
                          type={selectionType === "single" ? "radio" : "checkbox"}
                          name="group_selection"
                          id={`group-${group.id}`}
                          value={group.group_id}
                          checked={selectedIds.includes(group.group_id)}
                          onChange={() => handleSelect(group.group_id)}
                          disabled={disabled}
                        />
                        <label className="form-check-label" htmlFor={`group-${group.id}`}>
                          {group.title}{" "}
                          <span className="group-id group-selector__id">(ID: {group.group_id})</span>
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : null
          )
        ) : (
          <p className="text-muted group-selector__empty">Группы не найдены.</p>
        )}
      </div>
    </Form.Group>
  );
};

export default GroupSelector;
